import React from 'react';
import Widget from 'components/Widget/Widget';
import { metricsList } from '../components/metricsList';
import ChannelStackBar from './components/ChannelStackBar';
import ChannelWidgetTitle from './components/ChannelWidgetTitle';

const PnLByChannelsChart = ({ height = 500, data, configuration, index }) => {
  return (
    <Widget
      disableAccountsFilter
      widget_key={'PnLByChannelsChart' + index}
      title={data?.title}
      titleConfig={<ChannelWidgetTitle mode='widget' />}
      index={index}
      disableLevelFilter
      disableLimit
      disableStatusFilter
      default_filter={data.defaultFilter}
      configuration={configuration}
      metricsList={metricsList}
      data={data}
      load_chart={true}
      adsFilter
      adsetFilter
      campaignFilter
      showDatePicker
      showCustomDesign
      position={data?.position}
      dashboard_widget_key={data?.key}
    >
      <ChannelStackBar height={height - 50} />
    </Widget>
  );
};

export default PnLByChannelsChart;
